module.exports = __webpack_public_path__ + "img/thumb-ingredienten-gewokte-kip-broccoli.65c81f8a.jpeg";